import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=3c84fd35&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=ts"
export * from "./Coupon.vue?vue&type=script&lang=ts"
import style0 from "./Coupon.vue?vue&type=style&index=0&id=3c84fd35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c84fd35",
  null
  
)

export default component.exports